<ng-container *ngIf="!!element?.anexo_principal">
  <ng-container *ngIf="element?.iframe; else showLink">
    <div
      *ngIf="getSafeEmbedUrl(element.anexo_principal.link) as embedUrl; else other"
      class="flex h-[600px] w-full justify-center rounded-tl-2xl bg-white p-8"
    >
      <iframe [src]="embedUrl" frameborder="0" class="grid w-full select-none rounded-lg !bg-white"></iframe>
    </div>
    <ng-template #other>
      <div class="flex h-[600px] w-full justify-center rounded-tl-2xl bg-white p-8">
        <iframe
          [src]="element.anexo_principal.link | safe : 'resourceUrl'"
          frameborder="0"
          class="grid w-full select-none rounded-lg !bg-white"
        ></iframe>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #showLink>
    <div
      class="w-full rounded-tl-2xl bg-white px-10 pt-10 shadow-xl"
      [ngClass]="{
        'rounded-tr-2xl': fullWidth || fullSize,
        'rounded-bl-2xl rounded-br-2xl': fullSize,
        'pb-10': paddingBottom
      }"
    >
      <a
        style="word-break: break-all"
        class="flex items-center justify-start hover:text-theme-500"
        target="_blank"
        rel="noreferrer noopener"
        [href]="element.anexo_principal.link"
      >
        <svg-icon class="flex h-6 w-6 text-theme-500" src="assets/icons/icon-clip.svg"></svg-icon>
        <span class="pl-2">
          {{ element.anexo_principal.link | slice : 0 : 80 }}{{ element.anexo_principal.link.length > 80 ? '...' : '' }}
        </span>
      </a>
    </div>
  </ng-template>
</ng-container>
